/**
 * Created by Carsten Bühler
 * User: c.buehler on 14.11.2016
 * Copyright: xdot GmbH 2015
 */

import { AppContext } from '../app-context';
import ActionTypesCommon from '../constants/ActionTypesCommon';

export function handleDataUpdate(meta) {
    if (!AppContext.isWebsocketConnected() && meta && meta.className) {
        AppContext.getDispatcher().dispatch({
            type: ActionTypesCommon.DATA_UPDATE_MESSAGE,
            payload: {
                ...meta
            }
        });
    }
}


// WEBPACK FOOTER //
// ./js/utils/DataUpdateHandler.js